import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  height: 100%;

  .ant-form-item {
    width: 100%;
  }
`;

export const WrapperReasons = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  align-items: center;
  overflow: auto;
  .ant-form-item {
    width: 100%;
  }
  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    max-width: 50vw;
    max-height: 400px;
  }
`;
export const WrapperReasonsOnBoarding = styled.div<{ $isEverythingClear?: boolean | undefined }>`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  align-items: center;
  height: ${({ $isEverythingClear }) => ($isEverythingClear !== undefined ? '400px' : 'auto')};
  overflow: auto;
  .ant-form-item {
    width: 100%;
  }
  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    max-width: 50vw;
  }
`;
export const VoteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .ant-form-item {
    margin: 0;
  }
`;

export const SubtitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  color: ${({ theme }) => theme.colors.black7};
  padding: 12px 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    flex-direction: row;
    align-items: center;
  }
`;

export const FooterWrapper = styled.div`
  padding-top: 24px;
  width: 100%;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: center;
`;

export const TitleWrapper = styled.div`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black9};
  margin-bottom: 20px;
  text-overflow: ellipsis;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.2px;
`;

export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  font-size: 18px;
  padding: 16px;
  margin-top: 80px;
  align-items: center;
  justify-content: center;
`;

export const TextWrapper = styled.div`
  text-align: center;
  font-size: 18px;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  min-height: 300px;
`;

export const StepWrapper = styled.div<{ $hidden?: boolean }>`
  display: ${({ $hidden }) => ($hidden ? 'none' : 'block')};
  width: 100%;
`;
